import React, { useEffect, useRef } from "react";

const Contact = () => {
  const map = useRef();

  const executeScript = () => {
    const scriptTag = document.createElement("script");
    const inlineScript = document.createTextNode(`new daum.roughmap.Lander({
    	"timestamp" : "1686898562395",
      "key" : "2f7px",
      "mapHeight" : "500"
    }).render();`);
    scriptTag.appendChild(inlineScript);
    map.current.appendChild(scriptTag);
  };

  useEffect(() => {
    executeScript();
  }, []);

  return (
    <div id="contact" className="contact">
      <div className="container-sm px-2">
        <div ref={map}>
          <div id="daumRoughmapContainer1686898562395" className="root_daum_roughmap root_daum_roughmap_landing" style={{ width: "100%", borderRadius: "10px 10px 0px 0px" }}></div>
        </div>
        <div className="contact-info">
          <table className="table text-white">
            <tbody>
              <tr>
                <th scope="row" className="text-nowrap">주소</th>
                <td className="text-start">서울시 강남구 강남대로 94길 67 도연빌딩 7층 / 7F, Doyeon Bldg., 67, Gangnam-daero 94-gil, Gangnam-gu, Seoul, Republic of Korea</td>
              </tr>
              <tr>
                <th scope="row" className="text-nowrap">위치</th>
                <td className="text-start">2호선 역삼역 4번 출구</td>
              </tr>
              <tr>
                <th scope="row" className="text-nowrap">전화 / 팩스</th>
                <td className="text-start">02-554-5131 / 02-554-5132</td>
              </tr>
              <tr>
                <th scope="row" className="text-nowrap">메일</th>
                <td className="text-start">victor@amiesoft.com</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Contact;
